module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-VC-Australia-Website.fb417db0.webp";